exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Dialog__overall___15Bny {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 199; }\n  .Dialog__overall___15Bny .Dialog__dialog___3wEL3 {\n    background-color: #FFFFFF;\n    border-radius: .2em;\n    max-width: 90vw;\n    max-height: 90vh;\n    z-index: 200;\n    border-radius: 6px; }\n", ""]);

// exports
exports.locals = {
	"overall": "Dialog__overall___15Bny",
	"dialog": "Dialog__dialog___3wEL3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Dialogs/Dialog/Dialog.scss
// module id = 678
// module chunks = 0